import { Chain, ChainID } from '@ankr.com/chains-list';

import { isEVMBased } from 'modules/chains/utils/isEVMBased';
import { selectSubChainIdsByChainId } from 'modules/chains/store/selectors';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAppSelector } from 'store/useAppSelector';

import { useChainSelectors } from '../components/ChainSelectorsProvider';

export const useHasCodeExample = (chain: Chain) => {
  const { consensus, isConsensusEnabled } = useChainSelectors();

  const isBeaconSelected = isConsensusEnabled && consensus === 'beacon';

  const { isPremium } = useAccountStatus();
  const { id, premiumOnly } = chain;

  const allSubChainIds = useAppSelector(state =>
    selectSubChainIdsByChainId(state, id),
  );

  const hasEVMCompatibleSubchains =
    id === ChainID.MULTICHAIN || allSubChainIds.some(isEVMBased);

  const isCodeExampleDisabled =
    !hasEVMCompatibleSubchains ||
    (premiumOnly && !isPremium) ||
    isBeaconSelected;

  return !isCodeExampleDisabled;
};
